/** Page types */
export const PAGE_TYPES = {
    blog: 'Blog',
    homepage: 'Homepage',
    productPage: 'Product Page',
    landingPage: 'Landing Page',
    aboutUs: 'About Us',
    pricing: 'Pricing',
};
